export const getAlertUntilDate = (alertMessageLine) => {
  // Parse the date string to a Date object
  const parsedDate = new Date(alertMessageLine.replace('till:', ''));
  // Get the current year
  const currentYear = new Date().getFullYear();
  // Set the year of the parsed date to the current year
  parsedDate.setFullYear(currentYear);
  // Convert the modified date back to a locale string
  return parsedDate.toLocaleString();
};
